import { queryOptions, useQuery } from '@tanstack/react-query'

import { queryClient } from '@/src/general/utilities/query'

import { prayApi } from '../api/prayApi'
import type { REWARD_CITATION_TYPE } from '../models/rewardCitationType.enum'

const getRewardCitationsQueryOptions = ({ type }: { type?: REWARD_CITATION_TYPE }) =>
  queryOptions({
    queryKey: ['reward_citation', type],
    queryFn: ({ signal }) => prayApi.getRewardCitations({ type }, { signal }),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 15000,
  })

export const useRewardCitationsQuery = ({ type }: { type?: REWARD_CITATION_TYPE }) =>
  useQuery(getRewardCitationsQueryOptions({ type }))

export const prefetchRewardCitations = async ({ type }: { type?: REWARD_CITATION_TYPE }) =>
  queryClient.prefetchQuery({ ...getRewardCitationsQueryOptions({ type }), staleTime: 0, gcTime: 30000 })
